export default "__VITE_ASSET__D_zwyG_B__"